<script lang="ts">
  import Button, { type ButtonProps } from "./Button.svelte";
  import { Download } from "../icons/index.js";

  type Props = {
    disabled?: boolean;
    filename: string;
    headers: string[];
    rows: (string | number)[][];
    variant?: ButtonProps["variant"];
    size?: ButtonProps["size"];
    class?: string;
  };

  let {
    disabled = false,
    filename,
    headers,
    rows,
    variant = "tertiary",
    size = "sm",
    class: className,
  }: Props = $props();

  function exportToCSV() {
    const csvContent = [headers, ...rows].map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const downloadURL = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = downloadURL;
    a.download = filename;
    a.click();

    URL.revokeObjectURL(downloadURL);
  }
</script>

<Button {disabled} onclick={exportToCSV} {size} {variant} class={className}>
  {#snippet prefix()}
    <Download size={13} />
  {/snippet}
  Export Data
</Button>
